import { FromScreen } from 'src/app/models/from-screen';
import { Hold } from './models/hold';

export class GetHolds {
  static readonly type = '[Holds] - Get holds';
}

export class PostHold {
  static readonly type = '[Holds] - Post hold';

  constructor(
    public recordId: string,
    public from: FromScreen,
    public issueDate?: string,
    public rhId?: string
  ) {}
}

export class SetHold {
  static readonly type = '[Holds] - Set hold';

  constructor(public updatedHold: Hold) {}
}

export class RemoveHold {
  static readonly type = '[Holds] - Remove hold';

  constructor(public holdId: string) {}
}
